"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var specialtyApi = _interopRequireWildcard(require("@/api/specialtyApi.js"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  props: {},
  data: function data() {
    return {
      loading: false,
      constants: this.$constants,
      treeList: [],
      listPram: {},
      defaultImg: require('@/assets/imgs/moren.jpg')
    };
  },
  mounted: function mounted() {
    this.getAllList();
  },
  methods: {
    getAllList: function getAllList() {
      var _this = this;
      this.treeList = [];
      specialtyApi.listCategroy(this.listPram).then(function (res) {
        _this.treeList = res || [];
      });
    },
    // 编辑专区
    updateSpec: function updateSpec(id) {
      this.$router.push({
        path: "/applet/specialty/editSpec/".concat(id ? id : 0)
      });
    },
    removeSpec: function removeSpec(id) {
      var _this2 = this;
      this.$confirm('确定删除当前数据', '提示').then(function (result) {
        specialtyApi.DelArticle({
          id: id
        }).then(function (data) {
          _this2.$message.success('删除数据成功');
          _this2.getAllList();
        });
      });
    }
  }
};